"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAthenaResultSchemaType = exports.isAthenaQueryParams = exports.isAthenaTables = exports.isAthenaTable = void 0;
const schema = __importStar(require("../schema"));
const DataLake_1 = require("../types/DataLake");
const Log_1 = require("../types/Log");
const typeguardUtils_1 = require("./typeguardUtils");
exports.isAthenaTable = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.AthenaTableSchema,
    typeguardName: 'isAthenaTable',
});
const isAthenaTables = (obj) => {
    return Array.isArray(obj) && obj.every((el) => (0, exports.isAthenaTable)(el));
};
exports.isAthenaTables = isAthenaTables;
exports.isAthenaQueryParams = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.AthenaQueryParamsSchema,
    typeguardName: 'isAthenaQueryParams',
});
const isAthenaResultSchemaType = (obj, logOptions) => {
    let errorMessage = '';
    if (typeof obj !== 'string') {
        errorMessage = `Typeguard: detected non-string type as input, received [type:${typeof obj}]`;
    }
    else {
        const isAcceptedType = DataLake_1.AthenaQueryResultTypeIterable.some((field) => obj === field);
        if (!isAcceptedType) {
            errorMessage = `Typeguard: detected unsupported type:${typeof obj}] Athena Result Schema Type as input`;
        }
    }
    if (errorMessage) {
        if (logOptions === null || logOptions === void 0 ? void 0 : logOptions.logger) {
            const errObj = { message: errorMessage };
            logOptions.logger(errObj, logOptions.logLevel || Log_1.LogLevel.Error);
        }
        return false;
    }
    return true;
};
exports.isAthenaResultSchemaType = isAthenaResultSchemaType;
//# sourceMappingURL=datalake.js.map